import { Config, Sort } from '../types'

const defaultConfig: Config = {
  sort: Sort.desc,
}

export default defaultConfig
